import React from 'react';
import PropTypes from 'prop-types';
//widgets
import withStyles from '@material-ui/core/styles/withStyles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
//icons
import Warning from '@material-ui/icons/Warning';
//local
import { useOperator } from '../../contexts/OperatorContext';
import { useAppView } from '../../contexts/AppViewContext';
import { Loading } from '../Loading';

const withSystems =
  (systems = []) =>
  (Component) => {
    const systemLinks = {
      MediaRoom: (
        <a
          href="http://www.tangerineglobal.com/copy-of-mediaroom-commercial"
          target="_new"
        >
          CITRUS Mediaroom
        </a>
      ),
      Evolve: (
        <a
          href="http://www.tangerineglobal.com/copy-of-evolve-commercial"
          target="_new"
        >
          CITRUS Evolve
        </a>
      ),
      'Digital Signage': (
        <a
          href="http://www.tangerineglobal.com/copy-of-digital-signage"
          target="_new"
        >
          CITRUS Digital Signage
        </a>
      ),
      FTG: (
        <a
          href="http://www.tangerineglobal.com/copy-of-custom-hd-channels-4"
          target="_new"
        >
          CITRUS Channels
        </a>
      ),
      'Residential MediaRoom': (
        <a
          href="http://www.tangerineglobal.com/copy-of-mediaroom-residential"
          target="_new"
        >
          Residential MediaRoom
        </a>
      ),
      'Residential MediaFirst': (
        <a
          href="http://www.tangerineglobal.com/copy-of-mediafirst-residential-2"
          target="_new"
        >
          Residential MediaFirst
        </a>
      ),
    };
    const WithSystems = (props) => {
      const { classes, ...rest } = props;
      const operator = useOperator();
      const appView = useAppView();

      const hasSystem = systems.some((system) =>
        operator.systems.map((s) => s.name).includes(system)
      );

      if (appView.type === 'Operator' && operator.loading) return <Loading />;

      if (appView.type === 'Operator')
        hasSystem ? (
          <Component {...rest} />
        ) : (
          <div className={classes.root}>
            <Card>
              <CardContent>
                <Typography
                  variant="h4"
                  align="center"
                  gutterBottom
                  className={classes.warnBox}
                >
                  <Warning fontSize="large" className={classes.margin} /> Not
                  Available
                </Typography>
                <Typography variant="body2" gutterBottom>
                  This module is only available for resorts with our
                  {systems.map((system, index) => (
                    <span key={system}>
                      {index && systems.length > 2 ? ', ' : ' '}
                      {index && index === systems.length - 1 ? 'or ' : ''}
                      {systemLinks[system] || system}
                    </span>
                  ))}
                  {systems.length > 1 ? ' products.' : ' product.'}
                </Typography>
                <Typography variant="caption" gutterBottom>
                  {operator.name} has
                  {!operator.systems.length
                    ? ' no configured'
                    : operator.systems
                        .map((s) => s.name)
                        .map((system, index) => (
                          <span key={system}>
                            {index && operator.systems.length > 2
                              ? ', '
                              : index === 0
                              ? ' our '
                              : ' '}
                            {index && index === operator.systems.length - 1
                              ? 'and '
                              : ''}
                            {systemLinks[system] || system}
                          </span>
                        ))}
                  {operator.systems.length > 1 ? ' products.' : ' product.'}
                </Typography>
              </CardContent>
            </Card>
          </div>
        );

      return <Component {...rest} />;
    };

    WithSystems.propTypes = {
      classes: PropTypes.object.isRequired,
    };

    const styles = (theme) => ({
      root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(2),
      },
      card: {
        display: 'inline-flex',
      },
      warnBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      margin: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
      },
    });

    return withStyles(styles)(WithSystems);
  };

export default withSystems;
